import React from "react";

export default React.createContext({
	tenant: "demo",
	env: "portal.dev",
});
